<script lang="ts">
  import cornerTopLeft from 'src/components/main/#assets/top-left-border.svg'
  import cornerTopRight from 'src/components/main/#assets/top-right-border.svg'
  import cornerBottomLeft from 'src/components/main/#assets/bottom-left-border.svg'
  import cornerBottomRight from 'src/components/main/#assets/bottom-right-border.svg'
  import solana from './solana.svg'
  import solanaMobile from './solana-mobile.svg'
</script>

<section class="tokenomics" id="nft-tokenomics">
    <div class="container">
        <div class="title">
            NFT Tokenomics
            <div class="corner top-left" style="--cornerTopLeft: url({cornerTopLeft});"></div>
            <div class="corner top-right" style="--cornerTopRight: url({cornerTopRight});"></div>
            <div class="corner bottom-left" style="--cornerBottomLeft: url({cornerBottomLeft});"></div>
            <div class="corner bottom-right" style="--cornerBottomRight: url({cornerBottomRight});"></div>
        </div>
        <div class="row">
            <div class="d-none d-lg-block col-md-6">
                <div class="vertical-center">
                    <img src="{solana}" class="solana-logo" alt="">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="item">
                    <div class="number">1.</div>
                    <div class="item-title">Max Supply: 20 000 NFT</div>
                </div>
                <div class="item">
                    <div class="number">2.</div>
                    <div class="item-title">Mint in 3 stages</div>
                    <div class="item-description">Mint in 3 stages</div>
                </div>
                <div class="item">
                    <div class="number">3.</div>
                    <div class="item-title">Connected to game economy</div>
                </div>
                <div class="item">
                    <div class="number">4.</div>
                    <div class="item-title">Upgradable</div>
                    <div class="item-description">Use $LIS to upgrade Meowgons up to 100 lvl</div>
                </div>
                <div class="item">
                    <div class="number">5.</div>
                    <div class="item-title">Burn mechanic</div>
                    <div class="item-description">burn 3 units and get 1 random Meowgon</div>
                </div>
            </div>
            <div class="col d-lg-none">
                <div class="vertical-center">
                    <img src="{solanaMobile}" class="solana-logo" alt="">
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .tokenomics {
        position: relative;
        padding: 0 0 170px;
    }

    .title {
        font-size: 100px;
        font-weight: 700;
        padding: 18px 18px 0;
        background: linear-gradient(84deg, #FFF0E2 47%, #FFB287 71%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        line-height: normal;
        text-transform: uppercase;
        display: table;
        margin: 0 auto 100px;
        position: relative;
    }

    .corner {
        width: 15px;
        height: 15px;
        position: absolute;
        transition: .3s;
    }

    .corner.top-left {
        top: 0;
        left: 0;
        background: var(--cornerTopLeft) no-repeat top left;
    }

    .corner.top-right {
        top: 0;
        right: 0;
        background: var(--cornerTopRight) no-repeat top right;
    }

    .corner.bottom-left {
        bottom: 0;
        left: 0;
        background: var(--cornerBottomLeft) no-repeat bottom left;
    }

    .corner.bottom-right {
        bottom: 0;
        right: 0;
        background: var(--cornerBottomRight) no-repeat bottom right;
    }

    .solana-logo {
        width: 100%;
        max-width: 670px;
        height: auto;
        z-index: 2;
    }

    .item {
        border-top: 1px solid #6D6666;
        padding: 40px 0 40px 34px;
        position: relative;
    }

    .item:last-child {
        border-bottom: 1px solid #6D6666;
    }

    .number {
        position: absolute;
        font-size: 20px;
        font-weight: 500;
        left: 0;
        top: 40px;
        line-height: 100%;
        color: white;
    }

    .item-title {
        color: white;
        font-size: 40px;
        font-weight: 700;
        line-height: 100%;
        text-transform: uppercase;
    }

    .item-description {
        color: white;
        font-size: 18px;
        font-weight: 400;
        line-height: 150%;
        margin-top: 12px;
    }

    .vertical-center {
        display: flex;
        align-items: center;
        height: 100%;
        position: relative;
    }

    .vertical-center:before {
        content: "";
        border-radius: 626px;
        background: rgba(255, 107, 0, 0.18);
        filter: blur(100px);
        width: 626px;
        height: 626px;
        position: absolute;
        top: 60px;
        left: -210px;
    }

    @media(max-width: 1750px) {
        .solana-logo {
            max-width: 560px;
        }
    }

    @media(max-width: 1520px) {
        .item-title {
            font-size: 34px;
        }
    }

    @media(max-width: 1400px) {
        .title {
            font-size: 70px;
            margin: 0 auto 80px;
        }

        .solana-logo {
            max-width: 460px;
        }

        .item-title {
            font-size: 30px;
        }
    }

    @media(max-width: 1200px) {
        .solana-logo {
            max-width: 400px;
        }

        .item {
            padding: 30px 0 30px 34px;
        }

        .item-title {
            font-size: 26px;
        }

        .number {
            top: 35px;
        }

        .vertical-center:before {
            border-radius: 50%;
            width: 600px;
            height: 430px;
            left: -250px;
        }

        .title {
            font-size: 60px;
        }
    }

    @media(max-width: 991px) {
        .title {
            font-size: 40px;
            width: 100%;
            text-align: center;
            padding: 5px 10px 0;
            margin-bottom: 50px;
        }

        .tokenomics {
            padding: 25px 0 100px;
        }

        .item-title {
            font-size: 25px;
        }

        .number {
            font-size: 17px;
        }

        .solana-logo {
            margin: 20px auto 0;
        }

        .vertical-center:before {
            left: -150px;
            top: -450px;
        }

        .item {
            z-index: 2;
        }
    }

    @media(max-width: 767px) {
        .vertical-center:before {
            width: 100%;
        }
    }
</style>
